/**
* 图表界面
*/
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据可视化</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索，切换 -->
    <el-row :gutter="23">
      <el-col :span="18">
        <div class="stbgc">
          <el-row :gutter="23">
          </el-row>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stbgc">
          <el-row>
            <el-col :span="8" class="text-c">
              <el-radio v-model="formInline.type" label="week">周</el-radio>
            </el-col>
            <el-col :span="8" class="text-c">
              <el-radio v-model="formInline.type" label="month">月</el-radio>
            </el-col>
            <el-col :span="8" class="text-c">
              <el-radio v-model="formInline.type" label="years">年</el-radio>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-descriptions title="统计数据" :column="4" border>
        <el-descriptions-item label="总收入" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.totalIncome.value"  :title="statisticsData.totalIncome.title">
            <template slot="prefix">
              <i :class="statisticsData.totalIncome.iconClass" :style="statisticsData.totalIncome.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="手工总收入" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.handmadeIncome.value"  :title="statisticsData.handmadeIncome.title">
            <template slot="prefix">
              <i :class="statisticsData.handmadeIncome.iconClass" :style="statisticsData.handmadeIncome.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="卡总收入" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.cardTotalIncome.value"   :title="statisticsData.cardTotalIncome.title">
            <template slot="prefix">
              <i :class="statisticsData.cardTotalIncome.iconClass" :style="statisticsData.cardTotalIncome.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="利润"  sortable>
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.profit.value"  :title="statisticsData.profit.title">
            <template slot="prefix">
              <i :class="statisticsData.profit.iconClass" :style="statisticsData.profit.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="办卡总额" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.newCardTotalIncome.value"  :title="statisticsData.newCardTotalIncome.title">
            <template slot="prefix">
              <i :class="statisticsData.newCardTotalIncome.iconClass" :style="statisticsData.newCardTotalIncome.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="办卡率" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="0" :value="statisticsData.cardApplicationRate.value" suffix="%" :title="statisticsData.cardApplicationRate.title">
            <template slot="prefix">
              <i :class="statisticsData.cardApplicationRate.iconClass" :style="statisticsData.cardApplicationRate.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="续卡总额" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.renewalTotalIncome.value"  :title="statisticsData.renewalTotalIncome.title">
            <template slot="prefix">
              <i :class="statisticsData.renewalTotalIncome.iconClass" :style="statisticsData.renewalTotalIncome.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="续卡率" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="0" :value="statisticsData.renewalRate.value" suffix="%"  :title="statisticsData.renewalRate.title">
            <template slot="prefix">
              <i :class="statisticsData.renewalRate.iconClass" :style="statisticsData.renewalRate.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>

        <el-descriptions-item label="会员数" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.NumberMembers.value"  :title="statisticsData.NumberMembers.title">
            <template slot="prefix">
              <i :class="statisticsData.NumberMembers.iconClass" :style="statisticsData.NumberMembers.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="新客量" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.newCustomerVolume.value"   :title="statisticsData.newCustomerVolume.title">
            <template slot="prefix">
              <i :class="statisticsData.newCustomerVolume.iconClass" :style="statisticsData.newCustomerVolume.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
        <el-descriptions-item label="好评数" >
          <el-statistic group-separator="," style="font-size: 30px;" :precision="2" :value="statisticsData.NumberPositiveReviews.value"  :title="statisticsData.NumberPositiveReviews.title">
            <template slot="prefix">
              <i :class="statisticsData.NumberPositiveReviews.iconClass" :style="statisticsData.NumberPositiveReviews.iconStyle"></i>
            </template>
          </el-statistic>
        </el-descriptions-item>
      </el-descriptions>
    </el-row>
    <!-- 统计图 -->
    <el-row :gutter="23">
      <el-col :span="24" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="SUMEchart"  v-loading="sUMEchartLoading"></div>
        </div>
      </el-col>
      <el-col :span="12" class="text-c">
        <div class="paybox">
          <div class="cavasbox" ref="payEchart"></div>
        </div>
      </el-col>
      <el-col :span="12" class="text-c">
        <div class="paybox">
          <div class="cavasbox" ref="payNumEchart"></div>
        </div>
      </el-col>
      <el-col :span="24" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="SCEchart"></div>
        </div>
      </el-col>

      <el-col :span="24" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="ClickEchart"></div>
        </div>
      </el-col>
    </el-row>
    <!-- 统计图 -->
    <div>
      <el-row :gutter="23">

      </el-row>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Chart from 'echarts'
import {getIncomeTrendData, getManualTransPage, statisticsHeadQuery} from "../../api/payMG";
export default {
  name: "welcome",
  data() {
    return {
      like: true,
      loading:true,
      sUMEchartLoading:true,
      formInline: {
        dataType:'',
        type: 'month',
        token: localStorage.getItem('logintoken')
      },
      statisticsData:{
        profit: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        totalIncome: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        handmadeIncome: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        newCustomerVolume: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        cardApplicationRate: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        renewalRate: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        NumberPositiveReviews: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        NumberMembers: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        cardTotalIncome: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        newCardTotalIncome: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
        renewalTotalIncome: {
          value: 0,
          title: '',
          iconClass: '',
          iconStyle:''
        },
      },
      //  销售总笔数
      SCEoption: {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}月 : {c}"
        },
        legend: {
          data: [{
            name: '销售总笔数',
            icon: 'rect'
          }],
          top: 1,
          left: 1,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#323232"
          }
        },
        grid: {
          left: 50,
          right: 10,
          top: 30,
          bottom: 30,
          borderWidth: 1
        },
        xAxis: {
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        series: [{
          name: '利润走势',
          type: 'bar',
          barGap: 0,
          data: [50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000, 40000, 60000, 40000],
          barWidth: 10,
          itemStyle: {
            normal: {
              color: new Chart.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#83bff6' },
                  { offset: 0.5, color: '#188df0' },
                  { offset: 1, color: '#188df0' }
                ]
              )
            },
            emphasis: {
              color: new Chart.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' }
                ]
              )
            }
          }
        }]
      },
      //  近期利润走势
      SUMoption: {
        title: {
          text: '收入走势图'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['办卡金额', '充值金额', '非会员手工', '会员手工']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '四月', '五月', '六月', '七月']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '办卡金额',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '充值金额',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '非会员手工',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '会员手工',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: [320, 332, 301, 334, 390, 330, 320]
          }
        ]
      },
      //  总点击量
      Clickoption: {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}月 : {c}"
        },
        legend: {
          data: [{
            name: '总点击量',
            icon: 'rect'
          }],
          top: 1,
          left: 1,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#323232"
          }
        },
        grid: {
          left: 50,
          right: 10,
          top: 30,
          bottom: 30,
          borderWidth: 1
        },
        xAxis: {
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        series: [{
          name: '总点击量',
          type: 'bar',
          barGap: 0,
          data: [50000, 10000, 80000, 30000, 50000, 60000, 40000, 80000, 50000, 20000, 60000, 40000],
          barWidth: 10,
          itemStyle: {
            color: "#48cefd"
          }
        }]
      },
      //  支付方式统计
      payoption: {
        backgroundColor: '#2c343c',
        title: {
          text: '支付方式统计(金额)',
          left: 10,
          top: 5,
          textStyle: {
            fontSize: 12,
            color: '#ccc'
          }
        },

        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1]
          }
        },
        series: [
          {
            name: '支付方式统计(金额)',
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: [
              { value: 335, name: '支付宝' },
              { value: 310, name: '银商二维码' },
              { value: 274, name: '会员' },
              { value: 235, name: '微信支付' },
              { value: 100, name: 'Pos通' }
            ].sort(function (a, b) { return a.value - b.value; }),
            roseType: 'radius',
            label: {
              normal: {
                textStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                }
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            },
            itemStyle: {
              normal: {
                color: '#c23531',
                shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },

            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx) {
              return Math.random() * 200;
            }
          }
        ]
      },
      payNumoption: {
        backgroundColor: '#2c343c',
        title: {
          text: '支付方式统计(笔数)',
          left: 10,
          top: 5,
          textStyle: {
            fontSize: 12,
            color: '#ccc'
          }
        },

        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1]
          }
        },
        series: [
          {
            name: '支付方式统计(笔数)',
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: [
              { value: 335, name: '支付宝' },
              { value: 310, name: '银商二维码' },
              { value: 274, name: '会员' },
              { value: 235, name: '微信支付' },
              { value: 100, name: 'Pos通' }
            ].sort(function (a, b) { return a.value - b.value; }),
            roseType: 'radius',
            label: {
              normal: {
                textStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                }
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            },
            itemStyle: {
              normal: {
                color: '#c23531',
                shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },

            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx) {
              return Math.random() * 200;
            }
          }
        ]
      },
    }
  },
  // 导入组件
  components: {
    // 点聚合组件
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getStatisticsData('profit')
    this.getStatisticsData('totalIncome')
    this.getStatisticsData('handmadeIncome')
    this.getStatisticsData('newCustomerVolume')
    this.getStatisticsData('cardApplicationRate')
    this.getStatisticsData('renewalRate')
    this.getStatisticsData('NumberPositiveReviews')
    this.getStatisticsData('NumberMembers')
    this.getStatisticsData('cardTotalIncome')
    this.getStatisticsData('newCardTotalIncome')
    this.getStatisticsData('renewalTotalIncome')
    this.getIncomeTrendData()
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getSCE()
    this.getClick()
    this.getpay()
    this.getpayNum()
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 交易总笔数
    getSCE() {
      this.chart = Chart.init(this.$refs.SCEchart)
      this.chart.setOption(this.SCEoption)
    },
    // 交易总金额
    getSUM() {
      this.chart = Chart.init(this.$refs.SUMEchart)
      this.chart.setOption(this.SUMoption)
    },
    // 总点击量
    getClick() {
      this.chart = Chart.init(this.$refs.ClickEchart)
      this.chart.setOption(this.Clickoption)
    },
    // 支付方式统计
    getpay() {
      this.chart = Chart.init(this.$refs.payEchart)
      this.chart.setOption(this.payoption)
    },
    // 支付方式统计
    getpayNum() {
      this.chart = Chart.init(this.$refs.payNumEchart)
      this.chart.setOption(this.payNumoption)
    },
    getStatisticsData(obj){
      let form={};
      form.dataType=obj;
      form.type= this.formInline.type;
      form.token= this.formInline.token;
      statisticsHeadQuery(form)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.loading=false
            console.info(this.statisticsData[obj])
            // 分页赋值
            this.statisticsData[obj]=res.data
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    getIncomeTrendData(){
      this.sUMEchartLoading=true
      getIncomeTrendData(this.formInline)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.sUMEchartLoading=false
            this.SUMoption.xAxis[0].data=res.data.dates
            this.SUMoption.series[0].data=res.data.newCardAmount
            this.SUMoption.series[1].data=res.data.renewalAmount
            this.SUMoption.series[2].data=res.data.nonMemberAmount
            this.SUMoption.series[3].data=res.data.memberAmount
            this.chart = Chart.init(this.$refs.SUMEchart)
            this.chart.setOption(this.SUMoption)
          }
        })
        .catch(err => {
          this.sUMEchartLoading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })

    }

  }
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}
.stsearch {
  text-align: center;
}
.text-c {
  text-align: center;
}
.st-gbox {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}
.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
  height: 32vh;
}
.labelColorOne {
  background: #FDE2E2;
}

.my-content {
  background: #FDE2E2;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue